import { Component } from "@angular/core";
import { DataServiceService } from "../data-service.service";

@Component({
  selector: "app-partner-login-test",
  templateUrl: "./partner-login-test.component.html",
  styleUrls: ["./partner-login-test.component.scss"],
})
export class PartnerLoginTestComponent {
  username = "";
  password = "";
  isLoading = false;

  result: any = null;
  error: any = null;

  constructor(private dataService: DataServiceService) {}

  async login() {
    this.error = null;
    this.result = null;
    this.isLoading = true;
    try {
      const resp = await this.dataService.getPartnerAuthToken({
        username: this.username,
        password: this.password,
      });
      this.result = resp;
      if (resp && resp.token) {
        localStorage.setItem("token", resp.token);
      }
    } catch (e) {
      this.error = e;
    } finally {
      this.isLoading = false;
    }
  }

  clear() {
    this.result = null;
    this.error = null;
  }

  clearSavedToken() {
    localStorage.removeItem("token");
  }
}

